/* eslint-disable import/no-named-as-default */
import React from 'react'
import {
  Routes,
  Route,
} from 'react-router-dom'
import Page from 'src/components/Page'
import { makeStyles } from '@material-ui/core'
import PublicCourses from './publicCourse/PublicCourses'
import ProfessionalCourses from './professionalCourse/ProfessionalCourses'
import CertificateList from './CertificateList'
import CourseResult from './CourseResult'
import BoughtCourses from './boughtCourse/BoughtCourses'

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
    maxWidth: '100vw',
  },
}))
function CourseUser() {
  const classes = useStyle()

  return (
    <Page
      className={classes.root}
      title="دوره ها"
    >
      <Routes>
        <Route path="/public-courses/*" exact element={<PublicCourses />} />
        <Route path="/professional-courses/*" exact element={<ProfessionalCourses />} />
        <Route path="/course-result/*" exact element={<CourseResult />} />
        <Route path="/certificate" exact element={<CertificateList />} />
        <Route path="/bought-courses/*" exact element={<BoughtCourses />} />
      </Routes>
    </Page>
  )
}

export default CourseUser
